import CityPageTemplate from "../city-template/CityPageTemplate";
import { barHarborConfig } from "./data";

export default function BarHarborPage() {
  return <CityPageTemplate config={barHarborConfig} />;
}